{
  "title": "PoultryNEXT Legegeflügel",
  "title_Agrifirm": "PoultryNEXT Legegeflügel",
  "home": "Startseite",
  "save": "Speichern",
  "save-and-next-week": "Speichern und zur nächsten Woche gehen",
  "week": "Woche",
  "app": {
    "flock": "Herde",
    "settings": "Einstellungen",
    "management": "Verwaltung",
    "products": "Produkte",
    "advices": "Futterplan",
    "feed-advice": "Fütterungsempfehlung",
    "reference-scheme": "Referenzfutterhinweise",
    "breeders": "Züchter"
  },
  "settings": {
    "navigation": {
      "barns": "Ställe",
      "sustainability": "Nachhaltigkeit"
    },
    "barn": "Stall",
    "no-barns": {
      "description": "Füge einen Stall hinzu und er wird hier angezeigt.",
      "title": "Keine Ställe"
    },
    "barn-item": {
      "title-create": "Stall erstellen",
      "title-edit": "Stall bearbeiten",
      "add": "Hinzufügen",
      "area": "Stallfläche",
      "name": "Stallbeschreibung",
      "error-name-duplicate": "Dieser Stallname wird bereits verwendet. Geben Sie einen eindeutigen Stallnamen ein",
      "error-name-required": "Geben Sie den Stallnamen ein",
      "error-surface-area": "Geben Sie die Stallfläche ein",
      "delete-item": "Möchten Sie den Stall löschen?",
      "silo": "Silo"
    }
  },
  "egg-marketing-standards": {
    "organic": "Bio",
    "free-range": "Freilandhaltung",
    "cage-free": "Bodenhaltung",
    "caged": "Käfighaltung"
  },
  "flock-saved": "Die Herde wurde gespeichert",
  "confirm-delete-flock": "Möchten Sie die Herde wirklich löschen?",
  "flock-deleted": "Die Herde wurde gelöscht.",
  "flock-overview": {
    "flock": "Herde",
    "placeholder": "Wähle eine Herde",
    "selector-option-flock": "Herde",
    "selector-option-barn": "Stall",
    "print": "Bericht(e) drucken",
    "new-flock": "Neue Herde",
    "add-week": "Woche hinzufügen",
    "download-all": "Herdenbericht (.pdf)",
    "download-animal-count": "Tierzählungsbericht (.pdf)",
    "download-summary": "Zusammenfassung herunterladen (.pdf)",
    "panel": {
      "arrival-title": "Ankunft",
      "weekregistrations-title": "Wochenanmeldungen",
      "departure-title": "Ausstallung",
      "add-arrival": "Ankunft hinzufügen",
      "add-departure": "Ausstallung hinzufügen",
      "edit-arrival": "Ankunft bearbeiten",
      "edit-departure": "Ausstallung bearbeiten",
      "emptymessage-arrival": "Sie sollten zuerst eine Ankunft für diese Herde hinzufügen.",
      "emptymessage-weekregistrations": "Sie haben noch keine Wochenanmeldungen ausgefüllt.",
      "emptymessage-departure": "Sie haben noch keine Austallung definiert.",
      "flock-id": "Herden-ID",
      "egg-marketing-standard": "Eiervermarktungs-Standard",
      "hatchery-name": "Brüterei",
      "amount-of-hens": "Tierzahl",
      "breed-name": "Genetik",
      "barn-name": "Stall",
      "chick-birthdate": "Schlupfdatum",
      "arrival-date": "Ankunftsdatum",
      "delete": "Herde löschen",
      "departure-date": "Ausstalldatum",
      "departure-amount": "Anzahl",
      "departure-weight": "Hennengewicht (g)",
      "housing-system": "Stalltyp",
      "amount-of-roosters": "Anzahl der Hähne",
      "delete-breeder-flock": "Zuchtherde löschen",
      "feed-system-hens": "Fütterung Hennen",
      "feed-system-roosters": "Fütterung Hähne",
      "drink-system": "Tränkesystem",
      "hen-weight": "Hennengewicht (g)",
      "rooster-weight": "Hahnengewicht (g)",
      "nest": "Nest",
      "rearing-organization": "Aufzuchtbetrieb",
      "transport-distance": "Transport vom Aufzuchtbetrieb (km)"
    },
    "week-registrations": {
      "sortByAscending": "Woche aufsteigend",
      "sortByDescending": "Woche absteigend",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "kpis": {
        "AverageEggWeight": "Durchschnittliches Eigewicht",
        "AverageEggWeightPerLayerPerDay": "Eigewicht pro Henne pro Tag",
        "AverageLayerWeight": "durchschnittliches Legehennengewicht",
        "EggCountPerLayerInProduction": "Eier pro Henne",
        "EggCountPerLayerInProductionCumulative": "Eier pro Henne kumuliert",
        "FeedConsumption": "Futteraufnahme",
        "FeedConsumptionPerLayerInProduction": "Futteraufnahme pro Legehenne",
        "FeedConsumptionPerLayerInProductionCumulative": "Futteraufnahme pro Legehenne kumuliert (kg)",
        "FeedConsumptionPerLayerPerDay": "Futter pro Legehenne pro Tag",
        "FeedConsumptionPerLayerPerDayCumulative": "Futter pro Legehenne pro Tag kum",
        "FeedConversionRate": "Futterverwertung",
        "FeedConversionRateCumulative": "Futterverwertung kum",
        "FeedToEggRatio": "Futter/ Ei",
        "MortalityCount": "Mortalität",
        "MortalityRate": "Mortalitätsrate",
        "MortalityRateCumulative": "Mortalitätsrate kum",
        "RateOfLay": "Legeleistung",
        "TotalEggCount": "Anzahl Eier",
        "TotalEggCountSecondGrade": "Anzahl Eier zweite Klasse",
        "TotalEggWeight": "Gesamteigewicht",
        "TotalEggWeightPerLayerInProductionCumulative": "Eimasse pro Legehenne kum (kg)",
        "WaterConsumption": "Wasseraufnahme",
        "WaterToFeedRatio": "Wasser:Futter Verhältnis",
        "SecondFeedConsumption": "Gewicht 2. Futter"
      },
      "breeder-kpis": {
        "EggCount": "Eieranzahl",
        "EggWeightInGrams": "Eigewicht",
        "FertilityPercentage": "Fruchtbarkeit",
        "HatchPercentage": "Schlupfquote",
        "HatchPercentageCumulative": "Schlupfquote kumulativ",
        "HatchingEggCount": "Bruteieranzahl",
        "HenCount": "Anzahl Hennen",
        "HenFeedIntakeInGrams": "Futteraufnahme Hennen",
        "HenMortality": "Hennenverluste",
        "HenWeight": "Hennengewicht",
        "LightHours": "Lichtstunden",
        "LightIntensity": "Lichtintensitat",
        "RoosterCount": "Anzahl Hähne",
        "RoosterMortality": "Hahnenverluste",
        "RoosterPercentage": "Hähne %",
        "RoosterFeedIntakeInGrams": "Futteraufnahme Hahne",
        "WaterInLiters": "Wasser",
        "HenWaterIntakeInLiters": "Wasseraufnahme Hennen",
        "RoosterWaterIntakeInLiters": "Wasseraufnahme Hähne",
        "RoosterWeight": "Hahnengewicht",
        "RateOfLay": "Legeleistung",
        "RateOfLayCumulative": "Legeleistung kumulativ",
        "AverageEggWeight": "Durchschnittliches Eigewicht",
        "AverageEggWeightCumulative": "Durchschnittliches Eigewicht kumulativ",
        "EggMassPerBreeder": "Eimasse pro Zuchttier",
        "EggMassPerBreederCumulative": "Eimasse pro Zuchttier kumulativ",
        "FeedPerBreeder": "Futter pro Zuchttier",
        "FeedPerBreederCumulative": "Futter pro Zuchttier kumulativ",
        "FeedPerBreederPerDay": "Futter pro Zuchttier pro Tag",
        "FeedPerBreederPerDayCumulative": "Futter pro Zuchttier pro Tag kumulativ",
        "FeedPerHatchedEgg": "Futter pro Brutei",
        "FeedPerHatchedEggCumulative": "Futter pro Brutei kumulativ",
        "FeedToEggRatio": "Futter pro Ei",
        "FeedToEggRatioCumulative": "Futter pro Ei kumulativ",
        "FeedConversion": "Futterverwertung",
        "FeedConversionCumulative": "Futterverwertung kumulativ",
        "WaterToFeedRatio": "Wasser-Futter-Verhältnis",
        "WaterToFeedRatioCumulative": "Wasser-Futter-Verhältnis kumulativ",
        "MortalityRate": "Verlustrate",
        "MortalityRateCumulative": "Verlustrate kumulativ",
        "ProductionFigure": "Produktionszahl",
        "HatchedEggsPerPlacedHen": "Bruteier pro eingestallte Henne",
        "HatchedEggsPerPlacedHenCumulative": "Bruteier pro eingestallte Henne kumulativ",
        "HenMortalityRate": "Verlustrate Hennen",
        "HenMortalityRateCumulative": "Verlustrate Hennen kumulativ",
        "RoosterMortalityRate": "Verlustrate Hähne",
        "RoosterMortalityRateCumulative": "Verlustrate Hähne kumulativ",
        "HatchedEggsCumulative": "Bruteier kumulativ",
        "TotalFeedPerWeek": "Gesamtfutter (Woche)"
      },
      "view-filters": {
        "kpis": "KPIs",
        "manual-input": "Manuelle Eingabe",
        "moult": "induzierte Legepause",
        "remarks": "Bemerkungen",
        "detailed": "Ausführlich"
      },
      "filters": {
        "title": "Grafikeinstellungen",
        "description": "Hier finden Sie die Grafikeinstellungen.",
        "labels": {
          "breed-category-name": "Genetik",
          "egg-marketing-standard": "Eivermarktungs-Standard",
          "breed-name": "Genetik",
          "data-sources": "Angezeigte Datenquellen",
          "other-flock-placeholder": "Wähle eine Herde",
          "selector-option-barn": "Stall"
        },
        "breed-categories": {
          "overall": "Durchschnitt",
          "white": "Weiß",
          "brown": "Braun"
        },
        "egg-marketing-standards": {
          "0": "Bio",
          "1": "Freilandhaltung",
          "2": "Bodenhaltung",
          "3": "Käfighaltung"
        },
        "breeds": {
          "Overall": "Durchschnitt"
        },
        "chart-lines": {
          "current-flock": "Ausgewählte Herde",
          "breeders-reference-benchmark": "Referenzkarte Genetik",
          "porphyrio-benchmark": "Porphyrio-Benchmark",
          "other-flock": "Andere Herde",
          "other-flock-lower-case": "Andere Herde"
        }
      },
      "benchmark": {
        "title": "Wöchentliche Übersicht über",
        "description": "Hier finden Sie eine wöchentliche Übersicht der KPI:",
        "breedersReference": "Referenzkarte Genetik",
        "cumulative": "Kumulativ",
        "porphyrioBenchmark": "Porphyrio-Benchmark",
        "flocks": "Herden",
        "error": {
          "no-data-sources-title": "Keine Datenquellen verfügbar",
          "no-data-sources-description": "Eine Wochenübersicht kann nicht angezeigt werden, da keine Datenquellen ausgewählt wurden.",
          "no-data-title": "Keine Daten verfügbar",
          "no-data-description": "Für eine oder mehrere aktivierte Datenquelle(n) sind keine Daten verfügbar."
        },
        "axis": {
          "week": "Woche",
          "values": "Werte"
        }
      },
      "weekregistration-download": "Vorlage herunterladen",
      "weekregistration-upload": "Importieren",
      "weekregistration-select-file": "Datei auswählen...",
      "weekregistration-upload-csv-title": "Wählen Sie eine CSV-Datei zum Importieren",
      "upload-csv-message": "Spalten sollten nicht aus der Vorlage entfernt werden, auch wenn sie leer sind. Felder können leer gelassen werden.",
      "upload-csv-notification": "Wählen Sie eine CSV-Datei zum Importieren",
      "weekregistration-select-interval-type": "Intervall-Typ",
      "interval-type-Day": "Tag",
      "interval-type-Week": "Woche",
      "validation-errors": {
        "total-must-be-100": "Summe muss 100 sein",
        "date-is-not-valid-title": "Datum ist nicht korrekt",
        "date-is-not-valid-description": "Datum ist nicht korrekt"
      },
      "date": "Datum",
      "days": "Tage",
      "weeks": "Wochen",
      "jump-to-week": "Zur Woche"
    },
    "no-flocks": {
      "title": "Keine Herden",
      "description": "Füge eine Herde hinzu und sie wird hier angezeigt."
    },
    "unassigned": "Nicht zugewiesen",
    "new-breeder-flock": "Neue Zuchtherde"
  },
  "week-registration": {
    "mortality": "Mortalität",
    "eggsAmount": "Gesamtmenge an Eiern",
    "eggsAmountSecondKind": "Anzahl Eier 2. Klasse",
    "eggWeight": "Eigewicht",
    "forage": "Futter",
    "water": "Wasser",
    "henWeight": "Hennengewicht",
    "moult": "induzierte Legepause",
    "isInMoult": "induzierte Legepause",
    "isInMoultMessage": "induzierte Legepause diese Woche?",
    "moult-true": "Ja",
    "moult-false": "Nein",
    "remarks": "Bemerkungen",
    "amountOfHensStartOfWeek": "Anzahl der Hennen zu Wochenbeginn",
    "amountOfRoostersStartOfWeek": "Anzahl der Hähne zu Wochenbeginn",
    "amountOfHensStartOfFlock": "Anzahl der Hennen zu Beginn des Durchgangs",
    "amountOfRoostersStartOfFlock": "Anzahl der Hähne zu Beginn des Durchgangs",
    "henMortality": "Ausfall (Henne)",
    "roosterMortality": "Ausfall (Hahn)",
    "roosterWeight": "Gewicht (Hahn)",
    "henFeedIntakeInGrams": "Futteraufnahme in Gramm (Henne)",
    "roosterFeedIntakeInGrams": "Futteraufnahme in Gramm (Hahn)",
    "henWaterIntakeInLiters": "Wasseraufnahme in Litern (Henne)",
    "roosterWaterIntakeInLiters": "Wasseraufnahme in Litern (Hahn)",
    "eggCount": "Anzahl Eier",
    "hatchingEggCount": "Anzahl Bruteier",
    "eggWeightInGrams": "Eigewicht (in Gramm)",
    "fertilityPercentage": "Befruchtungsprozentsatz (1 Dezimalstelle)",
    "hatchPercentage": "Schlupfprozentsatz (1 Dezimalstelle)",
    "lightHours": "Lichtstunden",
    "lightIntensity": "Lichtintensität",
    "breed": "Genetik",
    "barn": "Stall",
    "dateOfBirth": "Schlupfdatum",
    "arrivalDate": "Einstalldatum",
    "week": "Woche",
    "week-start": "Wochenstart",
    "registration": "Anmeldung",
    "period": "Zeitraum",
    "out-of-range": "Dieser Wert ist außerhalb der Grenzen. Nur diese Werte sind erlaubt:",
    "whole-number-required": "Geben Sie eine ganze Zahl ein (ohne Dezimalstellen).",
    "hatching-egg-count-exceeds-egg-count": "Die Anzahl der Bruteier darf nicht größer sein als die Anzahl der Eier",
    "hatch-greater-than-fertility": "Der Schlupfprozentsatz muss niedriger als der Fruchtbarkeitsprozentsatz sein",
    "too-much-mortality": "Die Summe der Mortalität ist größer als die Anzahl der Hennen zu Wochenbeginn!",
    "forageProduct": "Futtermittel Bezeichnung",
    "secondForageToggle": "Weitere Futtersorte hinzufügen",
    "secondForage": "Weiteres Futter",
    "secondForageProduct": "Weitere Futtersorte",
    "weekly-registrations": "Wöchentliche Beobachtungsanmeldungen",
    "daily-registrations": "Tägliche Beobachtungsanmeldungen"
  },
  "arrival-detail": {
    "title-edit": "Ankunft bearbeiten",
    "title-create": "Ankunft erstellen",
    "flock-name": "Herdenname",
    "barn": "Stall",
    "chick-birthdate": "Schlupfdatum",
    "arrival-date": "Ankunftsdatum",
    "production-period-start-date": "Produktionszeitraum starten",
    "breed": "Genetik",
    "amount-of-hens": "Anzahl der Hühner",
    "egg-marketing-standard": "Eivermarktungs-Standard",
    "hatchery": "Brüterei",
    "input-mode": "Eingabe Methode",
    "input-mode-per-day": "Täglich",
    "input-mode-per-week": "Wöchentlich",
    "input-mode-advanced": "Individuell",
    "advanced-link": "Geben Sie die erweiterten Einstellungen ein >",
    "back-to-general-data": "< zurück",
    "advanced-settings-title": "Erweiterte Eingabeeinstellungen",
    "days": "Tage",
    "age-start-production-period": "Alter bei Produktionsbeginn",
    "housing-system": "Stalltyp",
    "bedding-type": "Einstreutyp",
    "bedding-amount": "Einstreumenge",
    "transport-distance": "Transport vom Aufzuchtbetrieb",
    "transport-distance-error": "Der Transport vom Aufzuchtbetrieb muss eine Zahl zwischen 0 und 1000 sein",
    "bedding-amount-error": "Die Menge an Einstreu muss eine positive Zahl sein",
    "time-in-free-range": "Zeit im Freiland",
    "time-in-free-range-error": "Die Zeit im Freiland muss eine Zahl zwischen 0 und 100 sein",
    "hen-weight": "Hennengewicht",
    "hen-weight-error": "Hühnergewicht muss eine positive Zahl sein",
    "hen-weight-comparison-error": "Das Gewicht muss geringer sein als beim Abflug",
    "minimum-amount-of-hens-error": "Die Anzahl der Hennen muss eine positive Zahl sein",
    "rearing-organization": "Aufzuchtbetrieb",
    "amount-of-roosters": "Anzahl der Hähne",
    "minimum-amount-of-roosters-error": "Die Anzahl der Hähne muss eine positive Zahl sein",
    "show-rooster-fields": "Hähne erfassen",
    "rooster-weight": "Hahnengewicht",
    "rooster-weight-error": "Hahnengewicht muss eine positive Zahl sein",
    "feed-system-hens": "Fütterungssystem Hennen",
    "feed-system-roosters": "Fütterungssystem Hähne",
    "drink-system": "Tränkesystem",
    "nest": "Nest"
  },
  "departure-detail": {
    "amount": "Tierzahl",
    "departureDate": "Ausstalldatum",
    "henWeightInGrams": "Hennengewicht",
    "eggs-price": "Eierpreis",
    "eggs-price-error": "Der Eierpreis muss eine positive Zahl sein",
    "pieces": "Stücke",
    "hens-price": "Preis der geschlachteten Hühner",
    "hens-price-error": "Der Preis der geschlachteten Hühner muss eine positive Zahl sein",
    "eggs-price-second-kind": "Preis für Eier der zweiten Klasse",
    "eggs-price-second-kind-error": "Der Preis der Zweitwahl-Eier muss eine positive Zahl sein",
    "hen-weight-error": "Hühnergewicht muss eine positive Zahl sein",
    "hen-weight-comparison-error": "Das Gewicht muss höher sein als bei der Ankunft",
    "minimum-amount-of-hens-error": "Die Anzahl der Hennen muss eine positive Zahl sein",
    "amount-of-hens-comparison-error": "Die Anzahl der Hennen darf nicht größer sein als bei der Ankunft",
    "departure-date-comparison-error": "Das Abreisedatum muss am oder nach dem frühestmöglichen Datum liegen"
  },
  "report": {
    "title_all": "Herdenbericht",
    "title_summary": "Zusammenfassung",
    "title_animalcount": "Tierzahl",
    "animalcount": {
      "year": "Zusammenfassung Jahr:",
      "year-placeholder": "- Wählen Sie ein Jahr -",
      "farmcompany": "Betrieb",
      "customernr": "Kundennummer",
      "contactperson": "Kontaktperson",
      "location": "Ort",
      "flock": "Herde",
      "barn": "Stall",
      "arrivaldate": "Ankunftsdatum",
      "arrivalamount": "Tierzahl Einstallung",
      "departuredate": "Ausstalldatum",
      "departureamount": "Tierzahl Ausstallung",
      "mutationdate": "Änderungsdatum",
      "reason": "Grund",
      "mutation": "Änderung",
      "amountbeforemutation": "Tierzahl vor Änderung",
      "amountaftermutation": "Tierzahl nach Änderung",
      "numberofdays": "Anzahl der Tage",
      "animaldays": "Tiertage",
      "average": "Durchschnittliche Anzahl",
      "total": "Gesamt",
      "reasons": {
        "EndOfLastYear": "Ende letzten Jahres",
        "Departure": "Ausstallung",
        "Mortality": "Mortalität",
        "EndOfYear": "Ende des Jahres",
        "Today": "Heute",
        "Arrival": "Ankunft"
      }
    },
    "customer-details": {
      "header": "Kundeninformation",
      "customer-number": "Kundennummer",
      "name": "Name",
      "address": "Adresse",
      "city": "PLZ und Ort",
      "phone": "Telefon",
      "location-name": "Standortnamen",
      "location-address": "Standort-Adresse",
      "location-city": "PLZ und Ort des Ortes",
      "location-phone": "Standorttelefon"
    },
    "flock-details": {
      "header": "Herdendetails",
      "flock": "Herde",
      "breed": "Genetik",
      "amount-of-hens": "Tierzahl",
      "marketing-standard": "Haltungsform",
      "arrival-date": "Ankunftsdatum",
      "departure-date": "Ausstalldatum",
      "age-start-production-period": "Alter zum Produktionsstart",
      "days": "Tage",
      "barn": "Stall"
    },
    "week-details": {
      "header": "Wochenmeldungen",
      "week": "Woche",
      "cumulative": "Kumulativ",
      "weekStart": "Wochenstart",
      "AverageEggWeight": "Durchschnittliches Eigewicht (g)",
      "AverageEggWeightPerLayerPerDay": "Eigewicht/Legehenne (g)",
      "AverageLayerWeight": "Legehennengewicht (g)",
      "EggCountPerLayerInProduction": "Eier pro Legehenne",
      "EggCountPerLayerInProductionCumulative": "Eier pro Legehenne kum.",
      "FeedConsumption": "Futteraufnahme (kg)",
      "FeedConsumptionPerLayerInProduction": "Futteraufnahme pro Legehenne (kg)",
      "FeedConsumptionPerLayerInProductionCumulative": "Futteraufnahme pro Legehenne kum (kg)",
      "FeedConsumptionPerLayerPerDay": "Futteraufnahme/Henne/Tag (g)",
      "FeedConsumptionPerLayerPerDayCumulative": "Futteraufnahme/Henne/Tag (g) kum",
      "FeedConversionRate": "Futterverwertung",
      "FeedConversionRateCumulative": "Futterverwertung kum",
      "FeedToEggRatio": "Futter/Ei (g)",
      "MortalityCount": "Mortalität",
      "MortalityRate": "Mortalitätsrate",
      "MortalityRateCumulative": "Mortalitätsrate kum",
      "RateOfLay": "Legeleistung",
      "TotalEggCount": "Anzahl Eier",
      "TotalEggCountSecondGrade": "Anzahl Eier zweite Klasse",
      "TotalEggWeight": "Gesamteigewicht (kg)",
      "TotalEggWeightPerLayerInProductionCumulative": "Eimasse pro Legehenne kum (kg)",
      "WaterConsumption": "Wasser (L)",
      "WaterToFeedRatio": "Wasser:Futter Verhältnis",
      "SecondFeedConsumption": "Gewicht 2. Futter (kg)"
    }
  },
  "validation-error": {
    "required": "Pflichtfeld",
    "title": "Validierungsfehler",
    "description": "Alle Felder müssen ausgefüllt werden."
  },
  "delivery-title": "Lieferungen",
  "delivery": {
    "search-placeholder": "Suche in Lieferscheinen",
    "overview-title": "Lieferungen Übersicht",
    "empty-title": "Keine Lieferungen gefunden",
    "empty-description": "Für diesen Ort wurden keine Lieferungen gefunden.",
    "overview-table": {
      "deliveryDate": "Datum",
      "deliveryNote": "Lieferschein",
      "orderNr": "Bestell nr",
      "productNr": "Produkt ID",
      "productName": "Produktname",
      "amount": "Höhe",
      "units": "Einheiten",
      "isActive": "Aktiv",
      "flock": "Herde",
      "edit-title": "Koppel Lieferung Bearbeiten"
    }
  },
  "product-title": "Produkte",
  "product-save": "Futtermittel speichern",
  "product-saved": "Produkt gespeichert!",
  "product-overview": {
    "title": "Produktübersicht",
    "overview": {
      "productName": "Name",
      "productCode": "Produkt-Code",
      "isActive": "Aktiv",
      "productType-Feed": "Futtermittel",
      "productType-Additive": "Zusatzstoff",
      "type": "Futtermitteltyp"
    },
    "no-products": {
      "title": "Keine Produkte gefunden",
      "description": "Durch Klicken auf Hinzufügen kann ein Futtermittel erstellt werden."
    },
    "delete-confirmation-title": "Futtermittel löschen",
    "delete-confirmation-message": "Sind Sie sicher, dass Sie dieses Futtermittel entfernen möchten?",
    "country": "Land"
  },
  "create-product": {
    "title-create": "Neues Produkt",
    "title-edit": "Produkt bearbeiten:",
    "product-name": "Futtermittelname",
    "product-code": "Futtermittel-Code",
    "error-product-name": "Bitte geben Sie den Namen des Futtermittels an.",
    "error-product-code": "Bitte geben Sie den Produktcode des Futtermittel ein.",
    "error-code-name-already-in-use": "Bitte verwenden Sie eine eindeutige Kombination aus Name und Code",
    "product-type": {
      "label": "Futtermitteltyp",
      "Feed": "Futtermittel",
      "Additive": "Zusatzstoff"
    },
    "error-product-type": "Der Futtermitteltyp ist erforderlich."
  },
  "countries": {
    "BE": "Belgien",
    "DE": "Deutschland",
    "FR": "Frankreich",
    "NL": "Niederlande",
    "JO": "Jordanien",
    "NG": "Nigeria",
    "TZ": "Tanzania",
    "KE": "Kenya",
    "UG": "Uganda"
  },
  "confirm-delete-flock-week-registration": "Sind Sie sicher, dass Sie die Wochenanmeldung löschen wollen?",
  "flock-week-registration-deleted": "Die Wochenmeldung wurde gelöscht.",
  "feed-advice": {
    "overview": {
      "title": "Fütterungsempfehlung Übersicht",
      "empty": {
        "title": "Fütterungshinweise nicht verfügbar",
        "description": "Zurzeit sind keine Futtermittelhinweise verfügbar."
      },
      "table-header": {
        "name": "Name",
        "created": "Erstellt",
        "updated": "Aktualisiert",
        "updatedAdvisorName": "Aktualisiert von",
        "isActive": "Aktiv"
      },
      "buttons": {
        "add": "Fütterungsempfehlung erstellen",
        "edit": "bearbeiten",
        "delete": "Löschen"
      }
    },
    "create-from-reference": {
      "title": "Fütterungsempfehlung erstellen",
      "scratch-title": "Ganz von vorne anfangen",
      "scratch-option-title": "Starten Sie einen Fütterungshinweis",
      "scratch-button": "Ganz von vorne anfangen",
      "scratch-option-subtitle": "Dies ist ein leerer Futtermittelhinweis",
      "reference-schemes-title": "Wählen Sie einen Referenzfuttermittelhinweis als Basis",
      "reference-schemes-button": "Beginnen Sie mit ",
      "product": "Futtermittel",
      "products": "Produkte",
      "additive": "Zusatzstoff",
      "additives": "Zusatzstoff"
    },
    "dialog": {
      "deleteConfirm": "Sind Sie sicher, dass Sie diesen Hinweis löschen möchten?",
      "deleteConfirmWhenInUse": "Dieser Futtermittelhinweis ist mit einem Zyklus verknüpft. Sind Sie sicher, dass Sie diesen Futtermittelhinweis löschen möchten?"
    },
    "create": {
      "print": "Drucken",
      "title": "Fütterungsempfehlung",
      "name": "Futterlinie",
      "error-name": "Ein Name für den Futtermittelhinweis ist erforderlich.",
      "description": "Beschreibung",
      "description-placeholder": "Beschreibung der Fütterungsempfehlung",
      "product-placeholder": "- Wählen Sie ein Futtermittel -",
      "add-product": "Futtermittel hinzufügen",
      "table-header": {
        "productName": "Produkt",
        "ageFrom": "Alter von (Wochen)",
        "ageTo": "Alter bis (Wochen)",
        "comment": "Kommentare",
        "age": "Alter (Wochen)",
        "dosage": "Dosierungsempfehlung",
        "applicationMoment": "Fütterungszeitraum"
      },
      "created": "Erstellt",
      "updated": "Aktualisiert",
      "validation-error": {
        "title": "Validierungsfehler",
        "feedadvice-name": "Feedadvice Name ist erforderlich",
        "age-from": "Alter von ist erforderlich",
        "product": "Futtermittel ist erforderlich",
        "age-to": "Alter bis ist erforderlich (außer in der letzten Zeile)",
        "age-min-max": "Das Alter von sollte niedriger sein als das Alter bis."
      },
      "products": "Bemerkungen",
      "additives": "Futtermittelzusatzstoffe",
      "show-additives": "Futtermittelzusatzstoffe anzeigen",
      "add-additive": "Hinzufügen"
    },
    "print": {
      "farmcompany": "Unternehmen",
      "customernr": "Kundennummer",
      "contactperson": "Kontaktperson",
      "location": "Standort",
      "customerservice": "Kundenbetreuung",
      "table-header": {
        "productName": "Produkt",
        "comment": "Kommentare",
        "dosage": "Dosierung",
        "units_kgton": "kg/Tonne",
        "applicationMoment": "Fütterungszeitraum",
        "units_weeks": "(Wochen)",
        "age": "Alter"
      }
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Referenz Fütterungsempfehlung Übersicht",
      "empty": {
        "title": "Referenzfutterhinweise nicht verfügbar",
        "description": "Zurzeit sind keine Referenzfuttermittel-Pläne verfügbar."
      },
      "table-header": {
        "name": "Name",
        "created": "Erstellt",
        "updated": "Aktualisiert",
        "updatedAdvisorName": "Aktualisiert von",
        "isActive": "Aktiv"
      },
      "buttons": {
        "add": "Referenz-Feed-Beratung erstellen",
        "edit": "bearbeiten",
        "delete": "Löschen"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "Sind Sie sicher, dass Sie diesen Hinweis auf Futtermittel löschen wollen?"
    },
    "create": {
      "title": "Referenz Fütterungsempfehlung",
      "name": "Name des Referenz-Futtermittelhinweises",
      "error-name": "Ein Name für den Referenzfuttermittelhinweis ist erforderlich.",
      "description": "Beschreibung",
      "description-placeholder": "Referenz Fütterungsempfehlung Beschreibung",
      "product-placeholder": "- Wählen Sie ein Futtermittel -",
      "add-product": "Futtermittel hinzufügen",
      "table-header": {
        "productName": "Produkt",
        "ageFrom": "Alter von (Wochen)",
        "ageTo": "Alter bis (Wochen)",
        "comment": "Kommentare"
      },
      "created": "Erstellt",
      "updated": "Aktualisiert"
    }
  },
  "housing-systems": {
    "aviary": "Voliere",
    "cages": "Käfige",
    "colony": "Kolonie",
    "floor": "Boden",
    "free-range": "Freilandhaltung",
    "furnished-cages": "ausgestaltete Käfige",
    "organic": "Bio"
  },
  "sustainability": {
    "sustainability": "Nachhaltigkeit",
    "add-farm-resources": "Hofressourcen hinzufügen",
    "farm-resources": "Energieverbrauch pro Jahr",
    "carbon-footprint": "c",
    "confirm-delete-farm-resource": "Die Hofressource löschen?",
    "farm-resource-deleted": "Hofressource gelöscht",
    "farm-resource-saved": "Hofressource gespeichert",
    "year": "Jahr",
    "resource": {
      "electricity": "Elektrizität (kWh)",
      "electricity-photovoltaic": "Elektrizität Sonne (kWh)",
      "electricity-wind": "Elektrizität Wind (kWh)",
      "natural-gas": "Erdgas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Benzin (L)",
      "coal": "Kohle (KG)",
      "propane-lpg": "Propan / LPG (L)",
      "water": "Wasser (m³)",
      "flock-start-date": "Startdatum",
      "flock-end-date": "Enddatum",
      "status": "Status",
      "statuses": {
        "complete": "Geschlossen",
        "partial": "Unvollständig",
        "active": "Aktiv"
      },
      "water-error": "Wasser muss eine positive Zahl sein",
      "electricity-error": "Elektrizität muss eine positive Zahl sein",
      "electricity-photovoltaic-error": "Strom Sonne muss eine positive Zahl sein",
      "electricity-wind-error": "Strom Wind muss eine positive Zahl sein",
      "natural-gas-error": "Erdgas muss eine positive Zahl sein",
      "diesel-error": "Diesel muss eine positive Zahl sein",
      "gasoline-error": "Benzin muss eine positive Zahl sein",
      "propane-lpg-error": "Propan/LPG muss eine positive Zahl sein",
      "coal-error": "Kohle muss eine positive Zahl sein"
    },
    "farm-settings-saved": "Hofeinstellungen gespeichert",
    "farm-settings-enable-co2-calculation": "CO2-Berechnungen für diesen Hof aktivieren",
    "flock-resources": "Ressourcen der Herde",
    "consumptionEgg": "Wert Eier (kg CO2eq / kg Eier)",
    "spentHens": "Wert geschlachteter Hennen (kg CO2äq / kg Hennenkörpergewicht)",
    "notification-title": "Wichtige Informationen über CO2-Berechnungen",
    "notification-description": "Die Berechnung des CO2-Fußabdrucks erfolgt mit der LCA-Software Sustell. Grundlage hierfür sind die CO2-Berechnungen des Futters gemäß der aktuellen Nevedi-Richtlinie. Für eine korrekte Berechnung müssen alle Daten vollständig eingegeben werden, wie zum Beispiel die <b>technischen Leistungen einer Herde inkl. Produktion, Abgang/Schlachtung und Energieverbrauch.</b>\nDie angezeigten Werte können sich aufgrund von Entwicklungen in der Klimawissenschaft und den daraus resultierenden Änderungen an den Berechnungssystemen sowie durch Änderungen von Gesetzen, Vorschriften und gegebenenfalls geltenden Standards ändern. Obwohl die hier dargestellten Informationen mit Sorgfalt zusammengestellt wurden, können daraus keine Rechte abgeleitet werden.",
    "action-text-close": "Ausblenden",
    "action-text-open": "Anzeige",
    "farm-resources-not-complete": "Die Herdenressourcen sind nicht vollständig.",
    "bedding-type-required": "Ankunft – Für die Herde ist eine bestimmte Einstreuart erforderlich.",
    "bedding-amount-required": "Ankunft – Für die Herde wird eine bestimmte Menge Einstreu benötigt.",
    "hen-weight-required": "Ankunft – Für die Herde wird das Gewicht der Hennen benötigt.",
    "start-calculation": "CO2-Berechnung starten",
    "refresh-carbon-footprint": "CO2-Fußabdruck aktualisieren",
    "carbon-footprint-title-error": "Fehler bei der Berechnung des CO2-Fußabdrucks",
    "carbon-footprint-title": "Berechnung des CO2-Fußabdrucks",
    "carbon-footprint-text": "Die Berechnung des CO2-Fußabdrucks wird gestartet. Bitte haben Sie etwas Geduld, während der Vorgang abgeschlossen wird (etwa 1 Minute).",
    "carbon-footprint-refresh-error-title": "Fehler beim Aktualisieren des CO2-Fußabdrucks",
    "week-registrations-required": "Für die Berechnung des CO₂-Fußabdrucks werden die Anmeldedaten der Woche benötigt.",
    "day-registrations-missing": "Für einige Wochen fehlen die täglichen Registrierungsdaten.",
    "week-registrations-incomplete": "Die wöchentlichen Meldungen müssen gültige Daten für den gesamten Bestandszeitraum enthalten.",
    "carbon-footprint-500-error-message": "Bei der Berechnung des CO₂-Fußabdrucks ist ein Fehler aufgetreten. Dies kann daran liegen, dass Ihre wöchentlichen Erfassungsdaten unvollständig sind oder fehlen. Bitte stellen Sie sicher, dass Sie die Produktionsdaten (Eier, Futterverbrauch, Sterblichkeit usw.) für den Zeitraum Ihrer Herde eingegeben haben, bevor Sie es erneut versuchen."
  },
  "bedding-types": {
    "NoBedding": "Keine Einstreu",
    "BarleyStraw": "Gerstenstroh",
    "MaizeStover": "Maisstroh",
    "OatStraw": "Haferstroh",
    "SawDust": "Sägemehl",
    "SunflowerHusk": "Sonnenblumenschale",
    "WheatStraw": "Weizenstroh",
    "Woodshavings": "Holzspäne"
  },
  "feed-systems": {
    "Ketting": "Kettenfuetterung",
    "Pannen": "Pfannenfuetterung",
    "Spiraal": "Spiralfuetterung"
  },
  "drink-systems": {
    "Cups": "Cups",
    "Nippels": "Nippeltraenken",
    "RondDrinkers": "Rundtraenken"
  },
  "nests": {
    "WegrolNest": "WegrolNest",
    "Handgeraapt": "Handgeraapt"
  },
  "title_Agravis": "Avidata Legehenne"
}
